import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
export var TILE_DEFAULTS = {
  kinds: ["ancestor", "parent", "child"],
  sizes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
};
export var Tile = forwardRefAs(function (_a, ref) {
  var _classNames;

  var className = _a.className,
      kind = _a.kind,
      size = _a.size,
      vertical = _a.vertical,
      rest = tslib_1.__rest(_a, ["className", "kind", "size", "vertical"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("tile", (_classNames = {}, _defineProperty(_classNames, "is-".concat(kind), kind), _defineProperty(_classNames, "is-".concat(size), size !== undefined), _defineProperty(_classNames, "is-vertical", vertical), _classNames), className),
    ref: ref
  }, rest));
}, {
  as: "div"
});
Tile.displayName = "Tile";
Tile.propTypes = {
  kind: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vertical: PropTypes.bool
};